if ($("#id_pagamento")[0])
    $("html, body").animate({ scrollTop: '100px' });

jQuery(document).ready(function ($) {
    $('.msk-card-number').mask('9999999999999999');
    $('.msk-security-number').mask('9999');
    $('.msk-cpf').mask('999.999.999-99');
    $('.msk-telefone').mask('(99) 9000-00000');
    $('.msk-data').mask('99/99/9999');

    if ($("#mp_button")[0]) {
        setTimeout(function () {
            $("#mp_button")[0].click();
        }, 3000);
    }

    $('body').delegate("#MP-Checkout-dialog > div", 'click', function () {
        location = $('body').data('url') + 'pagamento/mercadopago_verifica_conclusao';
    });

    $('input[name="cpf"]').each(function (index, input) {
        if (!$(input).val().length) {
            const cpfDiv = $(input).parent().parent().parent();

            cpfDiv.hide();

            cpfDiv.parent().find("input").click(function () {
                cpfDiv.show();
                $($('input[name="cpf"]').parent().parent().parent()[(index + 1) % 2]).hide();
            });
        }
    });
});

$('.page-content.pagamento .campo.campo-pagamento a').bind('click touchstart', function (event) {
    event.preventDefault();
    var father = $(this).parent().parent();
    var v = $(this).attr("data-tab");

    $('a', father).removeClass('is-active');
    $(this).addClass('is-active');
    $('.page-content.pagamento .campo.campo-pagamento select').val(v);

    $('.page-content.pagamento .metodo-pagamento').removeClass('is-active');
    $('.page-content.pagamento .metodo-pagamento.' + v).addClass('is-active');

    var id_pagamento = $(this).data('id');

    $("#id_pagamento").val(id_pagamento);
});

$('.page-content.pagamento .campo.campo-pagamento [name="metodo"]').on('init change', function () {
    if (!$(this).is(':checked')) return;
    var v = $(this).val();
    $('.page-content.pagamento .metodo-pagamento').removeClass('is-active');
    $('.page-content.pagamento .metodo-pagamento.' + v).addClass('is-active');
    $('.page-content.pagamento .campo.campo-pagamento a[data-tab=' + v + ']').click();

    var id_pagamento = $(this).data('id');

    $("#id_pagamento").val(id_pagamento);
});


$('form#pagamento input[name=cpfcnpj]').focusout(function (event) {
    if ($(this).val().length == 11) {
        $(this).mask("000.000.000-00");
    } else if ($(this).val().length > 11) {
        $(this).mask("00.000.000/0000-00");
    }
}).focusin(function (event) {
    $(this).mask("00000000000000")
});;


$('form#cadastrocpfboleto').submit(function (event) {
    var cpf = $('form#cadastrocpfboleto input[name=cpf], this');

    console.log(cpf.val())

    if (cpf.val().length < 13) {
        cpf.addClass('is-err');
        return false;
    }
});

$('form#cadastrocpfdeposito').submit(function (event) {
    var cpf = $('input[name=cpf], this');

    if (cpf.val().length < 13) {
        cpf.addClass('is-err');
        return false;
    }
});

$(".pagseguro #bandeiras-pagseguro").click(function () {
    $('form#pagamento').submit();
});






if ($(".metodo-pagamento.mercadopago").length) {
    // obter bandeira do cartão
    function addEvent(el, eventName, handler) {
        if (el.addEventListener) {
            el.addEventListener(eventName, handler);
        } else {
            el.attachEvent('on' + eventName, function () {
                handler.call(el);
            });
        }
    };


    // gerar token do cartão
    doSubmit = false;
    addEvent(document.querySelector('#pagamento'), 'submit', doPay);
    function doPay(event) {
        if ($('#id_pagamento').val() == 4) {
            event.preventDefault();

            var form = $("#pagamento");
            var mercado_pago = form.find('.mercadopago');

            var numero_cartao = mercado_pago.find('#cardNumber');
            var mes_expiracao = mercado_pago.find('#cardExpirationMonth');
            var ano_expiracao = mercado_pago.find('#cardExpirationYear');
            var codigo_seguranca = mercado_pago.find('#securityCode');
            var nome_titular = mercado_pago.find('#cardholderName');
            var cpf_titular = mercado_pago.find('#docNumber');
            var parcelas = mercado_pago.find('#installments');

            var err = 0;

            mercado_pago.find('input, select').removeClass('is-err');

            if (!numero_cartao.val().trim()) {
                numero_cartao.addClass('is-err');
                err = 1;
            } else {
                if (numero_cartao.val().trim().length < 14) {
                    numero_cartao.addClass('is-err');
                    err = 1;
                }
            }

            if (!mes_expiracao.val().trim()) {
                mes_expiracao.addClass('is-err');
                err = 1;
            } else {
                if (mes_expiracao.val().trim() > 12) {
                    mes_expiracao.addClass('is-err');
                    err = 1;
                }
            }

            if (!ano_expiracao.val().trim()) {
                ano_expiracao.addClass('is-err');
                err = 1;
            }

            if (!codigo_seguranca.val().trim()) {
                codigo_seguranca.addClass('is-err');
                err = 1;
            } else {
                if (codigo_seguranca.val().trim().length < 3) {
                    codigo_seguranca.addClass('is-err');
                    err = 1;
                }
            }

            // if (!nome_titular.val().trim().length) {
            //     nome_titular.addClass('is-err');
            //     err = 1;
            // } else {
            //     if (!/ /.test(nome_titular.val())) {
            //         nome_titular.addClass('is-err');
            //         err = 1;
            //     }
            // }

            if (!cpf_titular.val().trim().length) {
                cpf_titular.addClass('is-err');
                err = 1;
            } else {
                if (cpf_titular.val().length != 14) {
                    cpf_titular.addClass('is-err');
                    err = 1;
                }
            }

            if (!parcelas.val().trim().length || parcelas.val() < 0) {
                parcelas.addClass('is-err');
                err = 1;
            }

            if (!doSubmit && err === 0) {
                var $form = document.querySelector('#pagamento');

                Mercadopago.createToken($form, sdkResponseHandler); // The function "sdkResponseHandler" is defined below

                return false;
            }
        } else {
            return true;
        }
    }


    // verificar dados preenchidos e inserir token no form
    function sdkResponseHandler(status, response) {
        if (status != 200 && status != 201) {
            var error_msgs = [];

            for (var i in response.cause) {
                console.log(response.cause[i].description);
            }
        } else {
            var form = document.querySelector('#pagamento');

            var card = document.createElement('input');
            card.setAttribute('name', "token");
            card.setAttribute('type', "hidden");
            card.setAttribute('value', response.id);
            form.appendChild(card);
            doSubmit = true;
            form.submit();
        }
    }


    // mostra as parcelas e os bancos
    function getBin() {
        var cardSelector = document.querySelector("#cardId");
        if (cardSelector && cardSelector[cardSelector.options.selectedIndex].value != "-1") {
            return cardSelector[cardSelector.options.selectedIndex].getAttribute('first_six_digits');
        }
        var ccNumber = document.querySelector('input[data-checkout="cardNumber"]');
        return ccNumber.value.replace(/[ .-]/g, '').slice(0, 6);
    }

    function clearOptions() {
        var bin = getBin();
        if (bin.length == 0) {
            document.querySelector("#issuer").style.display = 'none';
            document.querySelector("#issuer").innerHTML = "";

            var selectorInstallments = document.querySelector("#installments"),
                fragment = document.createDocumentFragment(),
                option = new Option("Escolha", '-1');

            selectorInstallments.options.length = 0;
            fragment.appendChild(option);
            selectorInstallments.appendChild(fragment);
            selectorInstallments.setAttribute('disabled', 'disabled');
        }
    }

    function guessingPaymentMethod(event) {
        var bin = getBin(),
            amount = document.querySelector('#amount').value;
        if (event.type == "keyup") {
            if (bin.length == 6) {
                Mercadopago.getPaymentMethod({
                    "bin": bin
                }, setPaymentMethodInfo);
            }
        } else {
            setTimeout(function () {
                if (bin.length >= 6) {
                    Mercadopago.getPaymentMethod({
                        "bin": bin
                    }, setPaymentMethodInfo);
                }
            }, 100);
        }
    };

    function setPaymentMethodInfo(status, response) {
        if (status == 200) {
            // do somethings ex: show logo of the payment method
            var form = document.querySelector('#pagamento');

            if (document.querySelector("input[name=paymentMethodId]") == null) {
                var paymentMethod = document.createElement('input');
                paymentMethod.setAttribute('name', "paymentMethodId");
                paymentMethod.setAttribute('type', "hidden");
                paymentMethod.setAttribute('value', response[0].id);
                form.appendChild(paymentMethod);
            } else {
                document.querySelector("input[name=paymentMethodId]").value = response[0].id;
            }

            // check if the security code (ex: Tarshop) is required
            var cardConfiguration = response[0].settings,
                bin = getBin(),
                amount = document.querySelector('#amount').value;

            for (var index = 0; index < cardConfiguration.length; index++) {
                if (bin.match(cardConfiguration[index].bin.pattern) != null && cardConfiguration[index].security_code.length == 0) {
                    /*
                     * In this case you do not need the Security code. You can hide the input.
                     */
                } else {
                    /*
                     * In this case you NEED the Security code. You MUST show the input.
                     */
                }
            }

            Mercadopago.getInstallments({
                "bin": bin,
                "amount": amount
            }, setInstallmentInfo);

            // check if the issuer is necessary to pay
            var issuerMandatory = false,
                additionalInfo = response[0].additional_info_needed;

            for (var i = 0; i < additionalInfo.length; i++) {
                if (additionalInfo[i] == "issuer_id") {
                    issuerMandatory = true;
                }
            };
            if (issuerMandatory) {
                Mercadopago.getIssuers(response[0].id, showCardIssuers);
                addEvent(document.querySelector('#issuer'), 'change', setInstallmentsByIssuerId);
            } else {
                document.querySelector("#issuer").style.display = 'none';
                document.querySelector("#issuer").options.length = 0;
            }
        }
    };

    function showCardIssuers(status, issuers) {
        var issuersSelector = document.querySelector("#issuer"),
            fragment = document.createDocumentFragment();

        issuersSelector.options.length = 0;
        var option = new Option("Escolha", '-1');
        fragment.appendChild(option);

        for (var i = 0; i < issuers.length; i++) {
            if (issuers[i].name != "default") {
                option = new Option(issuers[i].name, issuers[i].id);
            } else {
                option = new Option("Otro", issuers[i].id);
            }
            fragment.appendChild(option);
        }
        issuersSelector.appendChild(fragment);
        issuersSelector.removeAttribute('disabled');
        document.querySelector("#issuer").removeAttribute('style');
    };

    function setInstallmentsByIssuerId(status, response) {
        var issuerId = document.querySelector('#issuer').value,
            amount = document.querySelector('#amount').value;

        if (issuerId === '-1') {
            return;
        }

        Mercadopago.getInstallments({
            "bin": getBin(),
            "amount": amount,
            "issuer_id": issuerId
        }, setInstallmentInfo);
    };

    function setInstallmentInfo(status, response) {
        var selectorInstallments = document.querySelector("#installments"),
            fragment = document.createDocumentFragment();

        selectorInstallments.options.length = 0;

        if (response.length > 0) {
            var option = new Option("Escolha", '-1'),
                payerCosts = response[0].payer_costs;

            fragment.appendChild(option);
            for (var i = 0; i < payerCosts.length; i++) {
                option = new Option(payerCosts[i].recommended_message || payerCosts[i].installments, payerCosts[i].installments);
                fragment.appendChild(option);
            }
            selectorInstallments.appendChild(fragment);
            selectorInstallments.removeAttribute('disabled');
        }
    };

    function cardsHandler() {
        clearOptions();
        var cardSelector = document.querySelector("#cardId"),
            amount = document.querySelector('#amount').value;

        if (cardSelector && cardSelector[cardSelector.options.selectedIndex].value != "-1") {
            var _bin = cardSelector[cardSelector.options.selectedIndex].getAttribute("first_six_digits");
            Mercadopago.getPaymentMethod({
                "bin": _bin
            }, setPaymentMethodInfo);
        }
    }

    addEvent(document.querySelector('input[data-checkout="cardNumber"]'), 'keyup', guessingPaymentMethod);
    addEvent(document.querySelector('input[data-checkout="cardNumber"]'), 'keyup', clearOptions);
    addEvent(document.querySelector('input[data-checkout="cardNumber"]'), 'change', guessingPaymentMethod);
    cardsHandler();
}

$('.cep_titular').on('input keyup', function () {
    var cep = $(this).val().replace('-', '');

    if (cep.length == 8) {
        $.ajax({
            url: 'https://viacep.com.br/ws/' + cep + '/json/?callback=?',
            method: 'get',
            dataType: 'json',
            success: function (data) {
                $('.logradouro_titular').val(data.logradouro);
                $('.bairro_titular').val(data.bairro);
                $('.cidade_titular').val(data.localidade);
                $('.estado_titular').val(data.uf);
            }
        });
    }

});